export const SeatAvailabilityRequest = ({
segment, oF, rF
}) => {


  return {
//   "clientCode": "string",
//   "key": "string",
//   "referenceNo": "string",
//   "supplierCode": "string",
//   "tokenId": "string",
//   "traceId": "string",
//   "index": "string",
//   "airPricing": [
//     {
//       "sCode": "string",
//       "supSource": "string",
//       "journey": "string",
//       "trip": 1,
//       "tripType": 1,
//       "planType": "string",
//       "origin": "del",
//       "destination": "bom",
//       "departDate": "string",
//       "returnDate": "string",
//       "adult": 1,
//       "child": 0,
//       "infant": 0,
//       "validatingCarrier": "string",
//       "flightKey": "string",
//       "fareKey": "string",
//       "flightDetails": [
//         {
//           "key": "string",
//           "group": 0,
//           "leg": 0,
//           "flightCount": 0,
//           "departAirportCode": "string",
//           "departAirportName": "string",
//           "departCityName": "string",
//           "departTerminal": "",
//           "departDateTime": "string",
//           "arrivalAirportCode": "string",
//           "arrivalAirportName": "string",
//           "arrivalCityName": "string",
//           "arrivalTerminal": "",
//           "arrivalDateTime": "string",
//           "flightNumber": "string",
//           "airLineCode": "string",
//           "airLineName": "string",
//           "duration": "string",
//           "availableSeats": "string",
//           "equipmentType": "string",
//           "marketingCarrier": "string",
//           "operatingCarrier": "string",
//           "operatingCarrierName": "string",
//           "operatingFlightNumber": "string",
//           "airLinePNR": "string",
//           "baggage": "string",
//           "travelClass": "string",
//           "otherDetails": "string",
//           "trackID": "string",
//           "bookingCode": "string",
//           "baggageDetails": [
//             {
//               "paxType": "string",
//               "baggage": "string",
//               "cabinBaggage": "string",
//               "journey": "string",
//               "origin": "string",
//               "destination": "string",
//               "baggageDesc": "string",
//               "cabinBaggageDesc": "string"
//             }
//           ],
//           "numberOfStops": 0,
//           "viaSector": "string",
//           "groundTime": "string"
//         }
//       ],
//       "paxFareRules": [
//         {
//           "lineNo": 0,
//           "leg": 0,
//           "flight": 0,
//           "paxType": "string",
//           "paxCabin": "string",
//           "paxFareBasis": "string",
//           "paxBookingClass": "string",
//           "paxFareType": "string",
//           "ruleNumber": "string",
//           "fareRuleKey": "string"
//         }
//       ],
//       "fareDetails": {
//         "farekey": "string",
//         "fareBasisCode": "string",
//         "rbd": "string",
//         "totalBaseFare": 0,
//         "totalFuelSurcharge": 0,
//         "totalOtherTax": 0,
//         "totalFare": 0,
//         "totalDiscount": 0,
//         "totalCashBack": 0,
//         "totalTDS": 0,
//         "totalServiceTax": 0,
//         "totalTransactionTFee": 0,
//         "paxFareDetails": [
//           {
//             "key": "string",
//             "paxType": "string",
//             "paxBaseFare": 0,
//             "paxFuelSurcharge": 0,
//             "paxOtherTax": 0,
//             "paxTotalFare": 0,
//             "paxDiscount": 0,
//             "paxCashBack": 0,
//             "paxTDS": 0,
//             "paxServiceTax": 0,
//             "paxTransactionFee": 0,
//             "text": "string",
//             "trackID": "string",
//             "fareIndex": "string",
//             "commissionEarned": 0,
//             "travelFee": 0,
//             "discount": 0,
//             "cgst": 0,
//             "sgst": 0,
//             "igst": 0,
//             "utgst": 0
//           }
//         ],
//         "paxFareRules": [
//           {
//             "lineNo": 0,
//             "leg": 0,
//             "flight": 0,
//             "paxType": "string",
//             "paxCabin": "string",
//             "paxFareBasis": "string",
//             "paxBookingClass": "string",
//             "paxFareType": "string",
//             "ruleNumber": "string",
//             "fareRuleKey": "string"
//           }
//         ],
//         "paxFares": [
//           {
//             "paxType": "string",
//             "totalPrice": "string",
//             "basePrice": "string",
//             "taxes": "string",
//             "serviceCharges": [
//               {
//                 "chargeType": "string",
//                 "collectType": "string",
//                 "chargeCode": "string",
//                 "ticketCode": "string",
//                 "currencyCode": "string",
//                 "chargeDetail": "string",
//                 "amount": "string",
//                 "transactionID": "string",
//                 "paxFareIndex": "string"
//               }
//             ],
//             "amount": "string",
//             "fareIndex": "string",
//             "transactionID": "string",
//             "trackID": "string"
//           }
//         ],
//         "netAmount": 0,
//         "companyAmount": 0,
//         "companyMarkUp": 0,
//         "agencyAmount": 0,
//         "agencyMarkUp": 0,
//         "trackID": "string",
//         "fareIndex": "string",
//         "penalties": [
//           {
//             "paxType": "string",
//             "changePenalty": "string",
//             "cancelPenalty": "string",
//             "refundability": "string",
//             "changePenaltyApplies": "string",
//             "cancelPenaltyApplies": "string"
//           }
//         ],
//         "baggageDetails": [
//           {
//             "paxType": "string",
//             "baggage": "string",
//             "cabinBaggage": "string",
//             "journey": "string",
//             "origin": "string",
//             "destination": "string",
//             "baggageDesc": "string",
//             "cabinBaggageDesc": "string"
//           }
//         ],
//         "minifarerules": [
//           {
//             "journeyPoints": "string",
//             "type": "string",
//             "from": "string",
//             "to": "string",
//             "unit": "string",
//             "details": "string"
//           }
//         ],
//         "commissionEarned": 0,
//         "travelFee": 0,
//         "classOfService": "string",
//         "sellFare": 0,
//         "discount": 0,
//         "cgst": 0,
//         "sgst": 0,
//         "igst": 0,
//         "utgst": 0,
//         "gstAmount": 0,
//         "fareUniqueKey": "string",
//         "tokenId": "string",
//         "iteamNo": 0,
//         "traceId": "string",
//         "sIndex": "string",
//         "isLCC": true,
//         "isRefundable": true,
//         "bagInfo": "string",
//         "connectionSegmentIndex": "string",
//         "productClass": "string",
//         "airlineRemark": "string",
//         "isGSTMandatory": true,
//         "agencyCommission": 0,
//         "tdsOnCommission": 0,
//         "gsTonAgencyCommission": 0,
//         "netAffiliateCommission": 0,
//         "amountPayable": 0,
//         "affCommissionPercentage": 0,
//         "managementFee": 0,
//         "managementFeeTax": 0,
//         "fareType": "string",
//         "supplierFareType": "string",
//         "bundlePrice": 0,
//         "journeyFareInfos": [
//           {
//             "key": "string",
//             "type": "string",
//             "fbc": "string",
//             "rbd": "string",
//             "cabin": "string",
//             "journey": "string",
//             "penalties": [
//               {
//                 "paxType": "string",
//                 "changePenalty": "string",
//                 "cancelPenalty": "string",
//                 "refundability": "string",
//                 "changePenaltyApplies": "string",
//                 "cancelPenaltyApplies": "string"
//               }
//             ],
//             "baggageDetails": [
//               {
//                 "paxType": "string",
//                 "baggage": "string",
//                 "cabinBaggage": "string",
//                 "journey": "string",
//                 "origin": "string",
//                 "destination": "string",
//                 "baggageDesc": "string",
//                 "cabinBaggageDesc": "string"
//               }
//             ],
//             "uniqueKey": "string",
//             "tokenId": "string",
//             "traceId": "string",
//             "isRefundable": true,
//             "supplierFareType": "string",
//             "seat": 0,
//             "encBaggage": "string"
//           }
//         ],
//         "isHoldAllowed": true,
//         "fareInclusions": [
//           "string"
//         ]
//       },
//       "tokenId": "string",
//       "traceId": "string",
//       "sIndex": "string",
//       "isLCC": true,
//       "baggageDetails": [
//         {
//           "code": "string",
//           "description": "string",
//           "origin": "string",
//           "destination": "string",
//           "text": "string"
//         }
//       ],
//       "mealDetails": [
//         {
//           "code": "string",
//           "description": "string",
//           "origin": "string",
//           "destination": "string"
//         }
//       ],
//       "totalDuration": "string",
//       "totalDurationReturn": "string",
//       "connectionSegmentIndex": "string",
//       "bagInfo": "string",
//       "isRefundable": true,
//       "productClass": "string",
//       "airlineRemark": "string",
//       "isGSTMandatory": true,
//       "isBookingHold": true,
//       "holdMessage": "string",
//       "bookingHoldOn": "2026-01-05T10:21:02.176Z",
//       "isPriceChange": true,
//       "paxOtherDetails": [
//         {
//           "paxType": "string",
//           "journey": "string"
//         }
//       ],
//       "error": {
//         "errorCode": "string",
//         "description": "string",
//         "category": "string"
//       },
//       "status": "string",
//       "agencyId": "string",
//       "fareType": "string",
//       "idType": "string",
//       "lastTicketDate": "string",
//       "preferredClass": "string"
//     }
//   ],
//   "destination": "bom",
//   "origin": "del",
//   "flightNumber": "string",
//   "airline": "6114",
//   "sessionID": "string"
  };
};
